import type { Transition, Variants } from 'motion/react';

/**
 * Las curvas del movimiento, en un solo lugar.
 *
 * Son los mismos valores que ya usaba el CSS (`--duration-enter`, `--ease`): la animación de un
 * panel y la de un botón tienen que sentirse del mismo producto, y eso se rompe apenas cada
 * componente elige su propia duración a ojo.
 */

/** `cubic-bezier(0.2, 0, 0, 1)` de tokens.css, en la forma que espera Motion. */
export const EASE = [0.2, 0, 0, 1] as const;

/** 220 ms · lo que tarda algo en aparecer. */
export const ENTER: Transition = { duration: 0.22, ease: EASE };

/** Más corto al salir que al entrar: irse tiene que sentirse resuelto, no ceremonioso. */
export const EXIT: Transition = { duration: 0.16, ease: EASE };

/**
 * Un resorte, para lo único que lo merece: el número que aparece cuando la estimación llega.
 *
 * Es el momento en que el producto entrega lo que promete. Un `fade` lo trataría igual que a
 * cualquier otro cambio de texto.
 */
export const LANDING: Transition = { type: 'spring', stiffness: 420, damping: 30, mass: 0.7 };

/** Entrada de pantalla: sube apenas y aparece. Nada de deslizamientos laterales. */
export const PAGE: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: ENTER },
  gone: { opacity: 0, transition: EXIT },
};

/** El fondo oscuro de un panel. Sólo opacidad: moverlo no aporta nada y marea. */
export const BACKDROP: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: ENTER },
  gone: { opacity: 0, transition: EXIT },
};

/** El panel que sube desde el borde inferior. */
export const SHEET: Variants = {
  hidden: { y: 24, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: ENTER },
  gone: { y: 24, opacity: 0, transition: EXIT },
};
